module.exports = "/static/media/back_arrow.031f4750.svg";